<div style="display:flex">
  <mat-icon>{{actions}}</mat-icon>
  <p style="color: white;">{{message}}</p>
  <mat-icon class="closeBtn" (click)="onClose()">clear</mat-icon>
</div>
